import React from 'react';
import { Chip, Tooltip } from '@mui/material';

// Stok minus terjadi bila penjualan offline dari aplikasi kasir (sudah dilayani saat server tidak
// terjangkau) melebihi stok tercatat. Penjualan tetap dicatat; admin perlu mencocokkan stok fisik.
const TandaStokMinus = ({ stok }) => {
  if (!(Number(stok) < 0)) return null;
  return (
    <Tooltip title="Stok minus karena penjualan offline melebihi stok tercatat. Cek stok fisik, lalu tambah stok atau koreksi.">
      <Chip label="Perlu dicek" color="error" size="small" sx={{ ml: 1, height: 20, fontSize: 11 }} />
    </Tooltip>
  );
};

export default TandaStokMinus;
